var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.hint ? _c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-on-focus": "",
      "open-on-click": "",
      "max-width": "320"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('button', _vm._g(_vm._b({
          staticClass: "stitch-hint",
          attrs: {
            "type": "button",
            "aria-label": _vm.hint
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              $event.preventDefault();
            },
            "keydown": function keydown($event) {
              $event.stopPropagation();
            }
          }
        }, 'button', attrs, false), on), [_c('v-icon', {
          attrs: {
            "size": "14"
          }
        }, [_vm._v("mdi-information-outline")])], 1)];
      }
    }], null, false, 3254364536)
  }, [_c('span', [_vm._v(_vm._s(_vm.hint))])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }